module.exports = __webpack_public_path__ + "img/feedback.24dafbe.svg";